module.exports = __webpack_public_path__ + "img/logo8.389066bc.png";